import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RecordsSearchFactory } from './records-search.factory';
import { SearchService } from '../search-service.interface';
import { RecordSearch } from './models/record-search.model';
import { SearchRequestBody, SearchRequestParams, SearchResponse } from '../search.model';
import { map, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { WishlistItem } from '../../../models/wishlist-item.model';
import { RecordSearchResponseData } from './models/record-search-response.data';

@Injectable({
  providedIn: 'root',
})
export class RecordsSearchService implements SearchService<RecordSearch> {
  private readonly recordsSearchFactory = inject(RecordsSearchFactory);
  private readonly http = inject(HttpClient);

  addToList(userId: string, listId: string, recordId: string): Observable<WishlistItem> {
    const url = `${environment.apiUrl}/patrons/${userId}/lists/${listId}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    });

    return this.http.post<WishlistItem>(url, `resourceId=${recordId}`, { headers });
  }

  removeFromList(userId: string, listId: string, recordId: string): Observable<void> {
    const url = `${environment.apiUrl}/patrons/${userId}/lists/${listId}/${recordId}`;

    return this.http.delete<void>(url);
  }

  search(params: SearchRequestParams, body: SearchRequestBody = null): Observable<SearchResponse<RecordSearch>> {
    const url = `${environment.apiUrl}/records/search`;

    return this.http.post<SearchResponse<RecordSearchResponseData>>(url, body, { params }).pipe(
      map((response) => ({
        ...response,
        data: response.data.map((responseRecord) => this.recordsSearchFactory.buildSearchRecord(responseRecord)),
      }))
    );
  }
}
